<template>
     <v-container>
        <div style="padding:10px; border-radius: 5px; background-color: #555; color: white;">
          Monitor
        </div>    
        <br>  
        <div style="padding:10px; border-radius: 5px; background-color: #555; color: white;">
           <span v-for="(content, index) in contents" :key="content['id']">
               {{ section }}.{{ index + 1 }} {{ content.question }} <br>
               Answer: {{ forms.monitor_score[index] ? 'Yes' : 'No' }} <br>
               Comment: {{ forms.monitor_comment[index] }} <br> <br>
            </span>
        </div> 
     </v-container>
</template>
<script>
import db from '@/components/firebase.init';
import Scale from '@/components/Scale';
export default {
    props:['section','forms'],
    data(){
        return{
            contents:[
                {
                    question:"Does the monitor have an anti-glare screen installed?",
                    parts: ['Neck']
                },
                {
                    question:"Is the monitor located in front of the user with top of the screen level with user’s eye?",
                    parts: ['Neck']
                },
                {
                    question:"Is the monitor tilted slightly upwards (10-20°, lower if user is wearing bifocal)?",
                    parts: ['Neck']
                },
                {
                    question:"Are the user’s eyes located between rows of overhead lights?",
                    parts: ['Neck']
                },
                {
                    question:`If using two monitors, they are positions for primary and
                            secondary use or for equal use and at the same height and
                            distance. I swivel on my chair (rather than repeatedly twisting my
                            neck) to visually navigate between them`,
                    parts: ['Neck']
                }
            ]
        }
    },
    methods:{
       
        initializeComment(){
            for(var i = 0; i < this.contents.length; i++){
                this.monitor_comment[i] = "";
            }
        }
    },
    components:{
        'scale' : Scale
    },
    mounted(){
        this.initializeComment();
    }
}
</script>

